<template>
  <div class="previewControll">
    <div class="previewContainer">
      <div v-if="!filterActive" class="filterToggle" @click="filterActive = !filterActive">
        <span class="material-symbols-outlined">tune</span>
        <span class="material-symbols-outlined">keyboard_arrow_down</span>
      </div>
      <transition name="fade-slide">
        <div v-if="filterActive" class="filterContainer">
          <Filter @filtered="changeDevice" @reseted="reset= false" @zoom="handleZoom" @previewPage="changePage" :reset="reset" @close="filterActive=false" />
        </div>
      </transition>
      <button v-bind:class="{rotated: this.rotated}" v-if="view !== 'Desktop'" @click="this.rotated = !this.rotated; this.reset= true">
        <span class="material-icons">screen_rotation</span>
      </button>
      <div v-if="view !== 'Desktop'">
        <TouchControll />
      </div>
      <div class='noClip' v-if="view=='Phone' && rotated == false">
        <div class='mockupPhone'>
          <div class='brove'><span class='speaker'></span></div>
          <div class="screen zoomScreen" :class=" {invert: colorMode == 'dark'}" v-dragscroll="true">
            <div ref="phone" class="Phone zoomable" >
              <MailPhone/>
            </div>
          </div>
        </div>
      </div>
      <div v-if="view=='Phone' && rotated">
        <div class='mockupPhoneR' >
          <div class='broveR'><span class='speakerR'></span></div>
          <div class="screenR zoomScreen"  v-dragscroll="true">
            <div ref="phone" class="PhoneR zoomable">
              <MailTabletRotated />
            </div>
          </div>
        </div>
      </div>
      <div class="mockupWrapper" v-if="view=='Tablet' && rotated">
      <div class='mockupTablet' >
        <div class='cameraTablet'></div>
        <div ref="tablet" class="screenTablet zoomScreen" v-dragscroll="true">
          <div class="Tablet zoomable">
            <MailTablet />
          </div>
        </div>
      </div>
      </div>
      <div class='mockupTabletR' v-if="view=='Tablet' && rotated == false">
        <div class='cameraTabletR'></div>
        <div ref="tablet" class="screenTabletR zoomScreen" v-dragscroll="true">
          <div class="TabletR zoomable">
            <MailTabletRotated />
          </div>
        </div>
      </div>
      <div class="mockupWrapper" v-if="view=='Desktop'">
      <div class='mockupDesktop'>
        <div class="screenDesktop zoomScreen" v-dragscroll="true">
          <div class="Desktop zoomable">
            <MailDesktop />
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
</template>

<script>
import Filter from './Filter.vue';
import MailPhone from './MailPhone.vue';
import MailDesktop from './MailDesktop.vue';
import MailTablet from './MailTablet.vue';
import MailTabletRotated from './MailTabletRotated.vue';
import TouchControll from './previewProps/TouchControll.vue';
import { dragscroll } from 'vue-dragscroll';
import {mapState } from 'vuex';

export default {
  name: 'PreviewControll',
  components: { Filter, MailDesktop, MailPhone, MailTablet, TouchControll, MailTabletRotated },
  directives: { dragscroll },
  data() {
    return {
      view: 'Phone',
      zoom: 1,
      rotated: false,
      reset: false,
      filterActive: false
    };
  },
  computed: {
    ...mapState(['colorMode'])},
  methods: {
    changeDevice(device) {
      this.view = device;
      this.rotated = false;
      document.querySelector('.zoomable').style.scale = 1;
    },
    changePage(page) {
      this.preview = page;
    },
    handleZoom(zoomLevel) {
      if (zoomLevel > 1) {
        this.zoom = zoomLevel;
        document.querySelector('.zoomable').style.scale = zoomLevel;
        document.querySelector('.zoomScreen').classList.add('zoomedScreen');
      } else if (zoomLevel == 1) {
        this.zoom = zoomLevel;
        document.querySelector('.zoomable').style.scale = zoomLevel;
        document.querySelector('.zoomScreen').classList.remove('zoomedScreen');
      }
    }
  }
};
</script>

<style scoped>
@import '../../styles/phone.css';
@import '../../styles/phoneRotated.css';
@import '../../styles/tablet.css';
@import '../../styles/tabletRotated.css';
@import '../../styles/desktop.css';

.zoomedScreen {
  overflow: scroll;
}

.zoomedScreen::-webkit-scrollbar {
  display: none;
}

.previewControll {
  max-width: 100%;
  max-height: 100%;
  background: transparent;
}

.previewContainer {
  max-width: 100%; 
  max-height: 100%;
  position: relative;
  overflow: none;
}

.mockupWrapper {
  width: 0;
  height: 0;
  overflow: visible;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.filterToggle {
  position: absolute;
  top: 0;
  margin: auto;
  margin-top: 0px;
  width: 250px;
  height: 25px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  background: white;
  z-index: 11;
  cursor: pointer;
  box-shadow: 0 0 20px #3a3838;
}

.filterContainer {
  width: 60%;
  position: absolute;
  top: 0;
  margin-top: 50px;
  z-index: 10;
}

.previewContainer {
  width: 100%;
  min-height: 100%;
  display: flex;
 /*  align-items: center; */
  justify-content: center;
  position: relative;
}

button {
  background: transparent;
  border: transparent;
  position: absolute;
  top: 15px;
  right: 15px;
  transform: rotate(45deg);
}

.touch {
  position: absolute;
  top: 15px;
  left: 15px;
}

.rotated {
  transform: rotate(135deg);
}

button:hover {
  cursor: pointer;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


.material-icons {
  font-size: 50px;
  color: white;
}

.Phone {
  margin: auto;
  height: 100%;
  width: 100%;
  user-select: none;
  transform-origin: top left;
}

.PhoneR {
  margin: auto;
  height: 100%;
  width: 100%;
  user-select: none;
  transform-origin: top left;
}

.Tablet {
  margin: auto;
  display: flex;
  height: 100%;
  width: 100%;
  user-select: none;
  transform-origin: top left;
}

.TabletR {
  margin: auto;
  display: flex;
  height: 100%;
  width: 100%;
  user-select: none;
  transform-origin: top left;
}

.Desktop {
  margin: auto;
  display: flex;
  width: 100%;
  height: 100%;
  user-select: none;
  transform-origin: top left;
}

.noClip {
  max-height: 900px;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter {
  opacity: 0;
  transform: translateY(-20px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
.invert {
  background: rgb(43, 43, 43);
  color: white;
}
</style>

